import { useEffect } from "react";
import "../styles/OurTeam.css";
import Kawaii from "../components/blob/Kawaii";

// Images

import tm1 from "../images-webp/members/suraj.webp";
import tm10 from "../images-webp/members/Ava.webp";
import tm11 from "../images-webp/members/sameer.webp";
import tm14 from "../images-webp/members/farhan.webp";
import tm15 from "../images-webp/members/chirag.webp";
import tm17 from "../images-webp/members/shobha.webp";
import tm18 from "../images-webp/members/palak.webp";
import tm19 from "../images-webp/members/humera.webp";
import tm20 from "../images/members/Jibin Joseph.jpg"
import tm21 from "../images/members/Bhaskar Sharma.jpg"
import tm22 from "../images/members/Srishti Pandey.jpeg"
import tm23 from "../images/members/Yash Tiwari.jpeg"
import tm24 from "../images/members/Hardik Khokhani.jpeg"
import tm25 from "../images/members/Om.jpg"
import tm26 from "../images/members/Ayush.jpg"
import tm27 from "../images/members/Hetvi.jpg"
import tm28 from "../images/members/Vrinda.jpg"
import tm29 from "../images/members/Isha.jpg"
import tm30 from "../images/members/Anshul.jpg"
import tm31 from "../images/members/Krushang.png"
import tm32 from "../images/members/Hardik.jpg"
import tm33 from "../images/members/Mahi.jpeg"

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles

// React Helmet
import { Helmet, HelmetProvider } from 'react-helmet-async';

// ..
AOS.init();

AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 50, // offset (in px) from the original trigger point
  delay: 400, // values from 0 to 3000, with step 50ms
  duration: 1000, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
});

function OurTeam() {
  function buttonClick() {
    document.getElementById("team__icon1").style.display = "none";
    document.getElementById("team__icon10").style.display = "block";
    document.getElementById("team__div14").style.display = "block";
  }
  function closeButton() {
    document.getElementById("team__icon1").style.display = "block";
    document.getElementById("team__icon10").style.display = "none";
    document.getElementById("team__div14").style.display = "none";
  }

  function buttonClicks() {
    document.getElementById("team__icon11").style.display = "none";
    document.getElementById("team__icon100").style.display = "block";
    document.getElementById("team__div144").style.display = "block";
  }
  function closeButtons() {
    document.getElementById("team__icon11").style.display = "block";
    document.getElementById("team__icon100").style.display = "none";
    document.getElementById("team__div144").style.display = "none";
  }

  function buttonClickss2() {
    document.getElementById("team__icon14").style.display = "none";
    document.getElementById("team__icon103").style.display = "block";
    document.getElementById("team__div147").style.display = "block";
  }
  function closeButtonss2() {
    document.getElementById("team__icon14").style.display = "block";
    document.getElementById("team__icon103").style.display = "none";
    document.getElementById("team__div147").style.display = "none";
  }

  // function buttonClickss4() {
  //   document.getElementById("team__icon16").style.display = "none";
  //   document.getElementById("team__icon105").style.display = "block";
  //   document.getElementById("team__div149").style.display = "block";
  // }
  // function closeButtonss4() {
  //   document.getElementById("team__icon16").style.display = "block";
  //   document.getElementById("team__icon105").style.display = "none";
  //   document.getElementById("team__div149").style.display = "none";
  // }

  function buttonClickss5() {
    document.getElementById("team__icon17").style.display = "none";
    document.getElementById("team__icon106").style.display = "block";
    document.getElementById("team__div150").style.display = "block";
  }
  function closeButtonss5() {
    document.getElementById("team__icon17").style.display = "block";
    document.getElementById("team__icon106").style.display = "none";
    document.getElementById("team__div150").style.display = "none";
  }

  function buttonClickss19() {
    document.getElementById("team__icon31").style.display = "none";
    document.getElementById("team__icon120").style.display = "block";
    document.getElementById("team__div164").style.display = "block";
  }
  function closeButtonss19() {
    document.getElementById("team__icon31").style.display = "block";
    document.getElementById("team__icon120").style.display = "none";
    document.getElementById("team__div164").style.display = "none";
  }

  function buttonClickss20() {
    document.getElementById("team__icon32").style.display = "none";
    document.getElementById("team__icon121").style.display = "block";
    document.getElementById("team__div165").style.display = "block";
  }
  function closeButtonss20() {
    document.getElementById("team__icon32").style.display = "block";
    document.getElementById("team__icon121").style.display = "none";
    document.getElementById("team__div165").style.display = "none";
  }

  function buttonClickss21() {
    document.getElementById("team__icon33").style.display = "none";
    document.getElementById("team__icon122").style.display = "block";
    document.getElementById("team__div166").style.display = "block";
  }
  function closeButtonss21() {
    document.getElementById("team__icon33").style.display = "block";
    document.getElementById("team__icon122").style.display = "none";
    document.getElementById("team__div166").style.display = "none";
  }
  function buttonClickss22() {
    document.getElementById("team__icon34").style.display = "none";
    document.getElementById("team__icon123").style.display = "block";
    document.getElementById("team__div167").style.display = "block";
  }
  function closeButtonss22() {
    document.getElementById("team__icon34").style.display = "block";
    document.getElementById("team__icon123").style.display = "none";
    document.getElementById("team__div167").style.display = "none";
  }
  function buttonClickss23() {
    document.getElementById("team__icon35").style.display = "none";
    document.getElementById("team__icon124").style.display = "block";
    document.getElementById("team__div168").style.display = "block";
  }
  function closeButtonss23() {
    document.getElementById("team__icon35").style.display = "block";
    document.getElementById("team__icon124").style.display = "none";
    document.getElementById("team__div168").style.display = "none";
  }
  function buttonClickss24() {
    document.getElementById("team__icon36").style.display = "none";
    document.getElementById("team__icon125").style.display = "block";
    document.getElementById("team__div169").style.display = "block";
  }
  function closeButtonss24() {
    document.getElementById("team__icon36").style.display = "block";
    document.getElementById("team__icon125").style.display = "none";
    document.getElementById("team__div169").style.display = "none";
  }
  function buttonClickss25() {
    document.getElementById("team__icon37").style.display = "none";
    document.getElementById("team__icon126").style.display = "block";
    document.getElementById("team__div170").style.display = "block";
  }
  function closeButtonss25() {
    document.getElementById("team__icon37").style.display = "block";
    document.getElementById("team__icon126").style.display = "none";
    document.getElementById("team__div170").style.display = "none";
  }
  function buttonClickss26() {
    document.getElementById("team__icon38").style.display = "none";
    document.getElementById("team__icon127").style.display = "block";
    document.getElementById("team__div171").style.display = "block";
  }
  function closeButtonss26() {
    document.getElementById("team__icon38").style.display = "block";
    document.getElementById("team__icon127").style.display = "none";
    document.getElementById("team__div171").style.display = "none";
  }
  function buttonClickss27() {
    document.getElementById("team__icon39").style.display = "none";
    document.getElementById("team__icon128").style.display = "block";
    document.getElementById("team__div172").style.display = "block";
  }
  function closeButtonss27() {
    document.getElementById("team__icon39").style.display = "block";
    document.getElementById("team__icon128").style.display = "none";
    document.getElementById("team__div172").style.display = "none";
  }
  function buttonClickss28() {
    document.getElementById("team__icon40").style.display = "none";
    document.getElementById("team__icon129").style.display = "block";
    document.getElementById("team__div173").style.display = "block";
  }
  function closeButtonss28() {
    document.getElementById("team__icon40").style.display = "block";
    document.getElementById("team__icon129").style.display = "none";
    document.getElementById("team__div173").style.display = "none";
  }
  function buttonClickss29() {
    document.getElementById("team__icon41").style.display = "none";
    document.getElementById("team__icon130").style.display = "block";
    document.getElementById("team__div174").style.display = "block";
  }
  function closeButtonss29() {
    document.getElementById("team__icon41").style.display = "block";
    document.getElementById("team__icon130").style.display = "none";
    document.getElementById("team__div174").style.display = "none";
  }
  function buttonClickss30() {
    document.getElementById("team__icon42").style.display = "none";
    document.getElementById("team__icon131").style.display = "block";
    document.getElementById("team__div175").style.display = "block";
  }
  function closeButtonss30() {
    document.getElementById("team__icon42").style.display = "block";
    document.getElementById("team__icon131").style.display = "none";
    document.getElementById("team__div175").style.display = "none";
  }
  function buttonClickss31() {
    document.getElementById("team__icon43").style.display = "none";
    document.getElementById("team__icon132").style.display = "block";
    document.getElementById("team__div176").style.display = "block";
  }
  function closeButtonss31() {
    document.getElementById("team__icon43").style.display = "block";
    document.getElementById("team__icon132").style.display = "none";
    document.getElementById("team__div176").style.display = "none";
  }
  function buttonClickss32() {
    document.getElementById("team__icon44").style.display = "none";
    document.getElementById("team__icon133").style.display = "block";
    document.getElementById("team__div177").style.display = "block";
  }
  function closeButtonss32() {
    document.getElementById("team__icon44").style.display = "block";
    document.getElementById("team__icon133").style.display = "none";
    document.getElementById("team__div177").style.display = "none";
  }
  function buttonClickss33() {
    document.getElementById("team__icon45").style.display = "none";
    document.getElementById("team__icon134").style.display = "block";
    document.getElementById("team__div178").style.display = "block";
  }
  function closeButtonss33() {
    document.getElementById("team__icon45").style.display = "block";
    document.getElementById("team__icon134").style.display = "none";
    document.getElementById("team__div178").style.display = "none";
  }
  function buttonClickss34() {
    document.getElementById("team__icon46").style.display = "none";
    document.getElementById("team__icon135").style.display = "block";
    document.getElementById("team__div179").style.display = "block";
  }
  function closeButtonss34() {
    document.getElementById("team__icon46").style.display = "block";
    document.getElementById("team__icon135").style.display = "none";
    document.getElementById("team__div179").style.display = "none";
  }
  function buttonClickss35() {
    document.getElementById("team__icon47").style.display = "none";
    document.getElementById("team__icon136").style.display = "block";
    document.getElementById("team__div180").style.display = "block";
  }
  function closeButtonss35() {
    document.getElementById("team__icon47").style.display = "block";
    document.getElementById("team__icon136").style.display = "none";
    document.getElementById("team__div180").style.display = "none";
  }

  useEffect(() => {
    document.getElementById("team__icon1").onclick = function () {
      buttonClick();
    };
    document.getElementById("team__icon10").onclick = function () {
      closeButton();
    };

    document.getElementById("team__icon11").onclick = function () {
      buttonClicks();
    };
    document.getElementById("team__icon100").onclick = function () {
      closeButtons();
    };

    document.getElementById("team__icon14").onclick = function () {
      buttonClickss2();
    };
    document.getElementById("team__icon103").onclick = function () {
      closeButtonss2();
    };

    // document.getElementById("team__icon16").onclick = function () {
    //   buttonClickss4();
    // };
    // document.getElementById("team__icon105").onclick = function () {
    //   closeButtonss4();
    // };

    document.getElementById("team__icon17").onclick = function () {
      buttonClickss5();
    };
    document.getElementById("team__icon106").onclick = function () {
      closeButtonss5();
    };

    document.getElementById("team__icon31").onclick = function () {
      buttonClickss19();
    };
    document.getElementById("team__icon120").onclick = function () {
      closeButtonss19();
    };

    document.getElementById("team__icon32").onclick = function () {
      buttonClickss20();
    };
    document.getElementById("team__icon121").onclick = function () {
      closeButtonss20();
    };

    document.getElementById("team__icon33").onclick = function () {
      buttonClickss21();
    };
    document.getElementById("team__icon122").onclick = function () {
      closeButtonss21();
    };

    document.getElementById("team__icon34").onclick = function () {
      buttonClickss22();
    };
    document.getElementById("team__icon123").onclick = function () {
      closeButtonss22();
    };

    document.getElementById("team__icon35").onclick = function () {
      buttonClickss23();
    };
    document.getElementById("team__icon124").onclick = function () {
      closeButtonss23();
    };

    document.getElementById("team__icon36").onclick = function () {
      buttonClickss24();
    };
    document.getElementById("team__icon125").onclick = function () {
      closeButtonss24();
    };

    document.getElementById("team__icon37").onclick = function () {
      buttonClickss25();
    };
    document.getElementById("team__icon126").onclick = function () {
      closeButtonss25();
    };

    document.getElementById("team__icon38").onclick = function () {
      buttonClickss26();
    };
    document.getElementById("team__icon127").onclick = function () {
      closeButtonss26();
    };

    document.getElementById("team__icon39").onclick = function () {
      buttonClickss27();
    };
    document.getElementById("team__icon128").onclick = function () {
      closeButtonss27();
    };

    document.getElementById("team__icon40").onclick = function () {
      buttonClickss28();
    };
    document.getElementById("team__icon129").onclick = function () {
      closeButtonss28();
    };

    document.getElementById("team__icon41").onclick = function () {
      buttonClickss29();
    };
    document.getElementById("team__icon130").onclick = function () {
      closeButtonss29();
    };

    document.getElementById("team__icon42").onclick = function () {
      buttonClickss30();
    };
    document.getElementById("team__icon131").onclick = function () {
      closeButtonss30();
    };

    document.getElementById("team__icon43").onclick = function () {
      buttonClickss31();
    };
    document.getElementById("team__icon132").onclick = function () {
      closeButtonss31();
    };

    document.getElementById("team__icon44").onclick = function () {
      buttonClickss32();
    };
    document.getElementById("team__icon133").onclick = function () {
      closeButtonss32();
    };

    document.getElementById("team__icon45").onclick = function () {
      buttonClickss33();
    };
    document.getElementById("team__icon134").onclick = function () {
      closeButtonss33();
    };

    document.getElementById("team__icon46").onclick = function () {
      buttonClickss34();
    };
    document.getElementById("team__icon135").onclick = function () {
      closeButtonss34();
    };

    document.getElementById("team__icon47").onclick = function () {
      buttonClickss35();
    };
    document.getElementById("team__icon136").onclick = function () {
      closeButtonss35();
    };
  }, []);

  return (
    <HelmetProvider>
    <div className="our__div1">
      <Helmet>
      {/* <!-- Primary Meta Tags --> */}
<title>Meet Tech Experts and Enthusiasts | iGeeks Media Pvt. Ltd.</title>
<meta name="title" content="Meet Tech Experts and Enthusiasts | iGeeks Media Pvt. Ltd." />
<meta name="description" content="Meet the amazing team at iGeeks Media Pvt. Ltd. We are
Apple geeks, editors, writers, content creators, and SEO analysts that
assure the delivery of the best Apple content globally." />

{/* <!-- Open Graph / Facebook --> */}
<meta property="og:type" content="website" />
<meta property="og:url" content="https://www.igeeksmedia.com/our-team/" />
<meta property="og:title" content="Meet Tech Experts and Enthusiasts | iGeeks Media Pvt. Ltd." />
<meta property="og:description" content="Meet the amazing team at iGeeks Media Pvt. Ltd. We are
Apple geeks, editors, writers, content creators, and SEO analysts that
assure the delivery of the best Apple content globally." />
<meta property="og:image" content="" />

{/* <!-- Twitter --> */}
<meta property="twitter:card" content="summary_large_image" />
<meta property="twitter:url" content="https://www.igeeksmedia.com/our-team/" />
<meta property="twitter:title" content="Meet Tech Experts and Enthusiasts | iGeeks Media Pvt. Ltd." />
<meta property="twitter:description" content="Meet the amazing team at iGeeks Media Pvt. Ltd. We are
Apple geeks, editors, writers, content creators, and SEO analysts that
assure the delivery of the best Apple content globally." />
<meta property="twitter:image" content="" />
      </Helmet>
      <div className="our__div2">
        <div className="home__div4">
          <div className="home__div000">
            <Kawaii />
          </div>
          <div className="home__div5"></div>
          <div className="carrer__div8" id="our_team">
            <p>
              <span>Our </span>
              <span>Team</span>
            </p>
          </div>
        </div>
        <div className="team__div1">
          <div className="team__div2">
            <div className="team__div3">
              <p>“Everyone here has the sense that right now is one of those moments when we are influencing the future.” <span style={{color: "#f2d729"}}>- Steve Jobs</span></p>
            </div>
          </div>
          <div className="team__div4">
            <div className="team__div5">
              <div data-aos="fade-up" className="team__div6 01 Suraj">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/surajpadmasali/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm1} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Suraj</p>
                      <p>Padmasali</p>
                    </div>
                    <div className="team__div7">
                  <p>Operations Head</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon1" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon10"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div14">
                    <p>
                    Suraj is the man who knows the ABCs of digital marketing. With over 10+ years of experience as an internet marketer, Suraj is one of the best Organic SEO and social media marketers in the tech biz. At iGeeksBlog, he leads the content team and helps ideate and edit how-to tutorials, troubleshooting guides, and more. Being an avid fan of Apple products himself, he constantly explores the latest tips and tricks to share with iGeeksBlog readers. Also a fitness freak, you can find him working out at the gym or listening to retro music when not on his screen.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  18 Palak">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/palakconnects/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm18} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Palak </p>
                      <p>Shah</p>
                    </div>
                    <div className="team__div7">
                  <p>Senior HR Executive</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon11" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon100"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div144">
                    <p>
                    Palak is a savvy HR professional with an entrepreneurial notion. Her forte is hiring top talent, performance management, and workforce planning. She believes in creating "Humans" rather than just "Resources" within the organization. Beyond work, Palak enjoys reading and engaging in fascinating conversations on entrepreneurship, psychology, fashion, tech, history, space, and art. In her leisure time, she enjoys sipping on tea, doing her nails, coloring mandalas, and playing BGMI while also nurturing her daughter's curiosities and exploring her areas of interest.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 t19 Humera">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/humeraconnects/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm19} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Humera </p>
                      <p>Shaikh</p>
                    </div>
                    <div className="team__div7">
                  <p>HR Executive</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon33" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon122"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div166">
                    <p>
                    On August 2016,I got my first job at the age of 17. Since then I have been passionate about my career. I have 6+ years of experience in corporate world. I have done versatile job roles. In 2019, I found my career interest as a Human Resource Executive. Apart from my work. I also like to travel and explore new places. Since past few years. I have been learning everyday and after joining iGeeks I feel really blessed. I am looking forward to explore new domains and new hike in my career.🚀
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  t19 Jibin">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/jibin-joseph-b9587a47" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm20} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Jibin</p>
                      <p>Joseph</p>
                    </div>
                    <div className="team__div7">
                  <p>Content Editor</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon34" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon123"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div167">
                    <p>
                    Meet our Content Editor, a dedicated Apple enthusiast with a passion for
editing and improving quality. With nuanced perspectives on history, politics,
art, and life in general, he brings a unique perspective to our team. When not
busy perfecting our content, you'll find him discussing Formula 1, football,
cricket, movies, shows, and food. Above all, he is a huge Messi fan!
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 t19 Hardik">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/hardik-khokhani/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm24} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Hardik</p>
                      <p>Khokhani</p>
                    </div>
                    <div className="team__div7">
                  <p>Creative Strategist</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon38" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon127"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div171">
                    <p>
                    Hardik is someone who has done it all. He is a Mechanical Engineer who also
has been a Radio Jockey for more than half a decade for a National Network.
He has also worked with a Nationalised Educational Institution and helped
them build content for their YouTube. He is a movie and a tech enthusiast who
loves the world of visual content and can spend endless hours watching
content online. He strongly believes that if his content brings difference to
even one person watching it then his job is more than accomplished.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  11 Sameer">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/sameer-sharma-b3012911b/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm11} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10 right10">
                    <div className="team__div11">
                      <p>Sameer </p>
                      <p>Sharma</p>
                    </div>
                    <div className="team__div7">
                  <p>Video Editor & Content Creator</p>
                </div>
                    <div className="team__div12 right12">
                      <div className="team__div13">
                        <AddIcon id="team__icon14" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon103"
                          className="team__icon100 right100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14 right14" id="team__div147">
                    <p>
                    Tech, Bikes, and Games are three things that define Sameer's life. Being a former Journalism and Mass Communication graduate, he has a fine understanding of working in the Tech Media World. Sameer has been fascinated by technology for the past 13 years and is always on the hunt for new technology releases and events. He presently edits and creates videos for the iGeeksBlog Hindi YouTube channel. When he is not working on videos, he enjoys riding his bike through the wilderness. Have you checked his podcast yet?
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 15 Chirag">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/nayakchirag5/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm15} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Chirag </p>
                      <p>Nayak</p>
                    </div>
                    <div className="team__div7">
                  <p>Video Editor</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon17" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon106"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div150">
                    <p>
                    Chirag is an iGeeksBlog video editor that concentrates on beautifying and refining iGeeksBlog's YouTube and Instagram video content. He loves bringing imagery to life and is always trying out new approaches and styles. He's worked on prime-time TV shows, reality shows, documentaries, movie trailers, and music video clips, among other things. He can be seen playing video games, watching movies, or listening to music when he is not at the editing table.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  t19 Hardik_Kargathara">
                
                <div className="team__div8">
                  <a href=" https://www.linkedin.com/in/hopeofhardik/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm32} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Hardik</p>
                      <p>Kargathara</p>
                    </div>
                    <div className="team__div7">
                  <p>Social Media Strategist</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon46" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon135"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div179">
                    <p>
                    Hardik is our Social Media Strategist. With a passion for digital marketing and a keen understanding of social media platforms, Hardik excels in creating effective strategies to enhance brand visibility, engage audiences, and drive organic growth. Armed with a deep knowledge of the latest industry trends and insights, he leverages innovative tactics to optimize social media campaigns and maximize results.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 t19 Krushang">
                
                <div className="team__div8">
                  <a href="https://in.linkedin.com/in/krushangshah" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm31} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Krushang </p>
                      <p>Shah</p>
                    </div>
                    <div className="team__div7">
                  <p>SEO Manager</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon45" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon134"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div178">
                    <p>
                    Krushang is like a Swiss army knife in SEO. He has two master's degrees in
computer science and is currently studying at IIM Ahmedabad. He is one of the
rarest SEO professionals with a data driven approach. He is one of the friendliest
and finest people to work with. He can literally force Google to show what’s
intended on SERP. A fun-loving technical SEO specialist that can turn the table in
favor with the help of most advanced technical Seo expertise. He likes to share
and discuss good things and ideas with others.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  10 Ava">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/ava-biswas/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm10} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Ava </p>
                      <p>Biswas</p>
                    </div>
                    <div className="team__div7">
                  <p>Content Writer</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon31" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon120"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div164">
                    <p>
                    A geeky potato who loves to decode the tech through words. Her honest product reviews help our readers to take a breath of relief and check out the most suitable products for themselves. Besides, she writes easy-to-do tutorials with extensive research so that everyone may return with a solution always. You may find her cooking, exploring different cuisines, and vlogging if she is not typing.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 t19 Bhaskar">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/bhaskarsharma2510/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm21} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Bhaskar</p>
                      <p>Sharma</p>
                    </div>
                    <div className="team__div7">
                  <p>Content Writer</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon35" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon124"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div168">
                    <p>
                    Bhaskar is the word wizard of the iGB clan! With his magical ability to create
catchy web and app experiences, he can weave words and rhythms like no
other. When he's not honing his writing skills, you'll find him strumming his
guitar or passionately playing a game of sports. As the sun begins to set, be on
the lookout for his enchanting quotes that are bound to grace your Instagram
feed with their irresistible charm.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  17 Shobha">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/shobha-tiwari-3a6aa8b1/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm17} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Shobha </p>
                      <p>Tiwari</p>
                    </div>
                    <div className="team__div7">
                  <p>Social Media Executive</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon32" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon121"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div165">
                    <p>
                    Journalist, Researcher, Script Writer, Digital Geek Inquisitorial, Shutterbug, AND All Around Seeker.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 t19 Mahi">
                
                <div className="team__div8">
                  <a href=" https://www.linkedin.com/in/mahi-ramavat-670847246/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm33} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Mahi</p>
                      <p>Ramavat</p>
                    </div>
                    <div className="team__div7">
                  <p>Cinematographer + Video Editor</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon47" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon136"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div180">
                    <p>
                    Say cheese to our cinematographer-cum-video editor. Mahi is a passionate about capturing the perfect shot to bring a director's vision to life. He's an expert in lighting, camera angles, and shot composition, and then uses his editing skills to create visually stunning videos. When not working on a project, you'll find Mahi experimenting with new camera techniques, exploring new camera gadgets, and developing new video shoot ideas.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  t19 Yash">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/yashislive/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm23} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Yash</p>
                      <p>Tiwari</p>
                    </div>
                    <div className="team__div7">
                  <p>Content Writer</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon37" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon126"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div170">
                    <p>
                    Yash is a driven individual with a passion for technology and its impact on our
world. His aim is to educate and inform others about the newest
advancements in technology and how they can benefit society. In consonance,
he is deeply indulged in anime and Marvel Cinematic Universe, if not writing.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 t19 Srishti">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/srishti-pandey-186458171" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm22} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Srishti</p>
                      <p>Pandey</p>
                    </div>
                    <div className="team__div7">
                  <p>Content Writer</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon36" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon125"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div169">
                    <p>
                    A voracious writer who loves to give words to the complexities of the

technological arena. I like to do research on your part and write easy-to-
understand tutorials so you never feel lost in the pool of offerings. When not

writing, you will find me listening to BTS songs or gushing over their talent.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  t19 Anshul">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/anshulsharma1731" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm30} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Anshul </p>
                      <p>Sharma</p>
                    </div>
                    <div className="team__div7">
                  <p>Content Creator</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon44" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon133"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div177">
                    <p>
                    Say hello to Anshul Sharma, a passionate Content Creator at iGeeks Media. He
enjoys sharing the latest Apple, tech and AI tools insights. Besides that, Anshul is
an avid traveler, cyclist, and bookworm, who loves exploring the world one
adventure at a time.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 t19 Ayush">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/ayush-patel-tech-writer/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm26} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Ayush </p>
                      <p>Patel</p>
                    </div>
                    <div className="team__div7">
                  <p>Content Writer</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon40" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon129"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div173">
                    <p>
                    Ayush is a tech enthusiast turned tech journalist and how-to writer who crafts
exceptional blog posts. His expertise lies in delivering clear and concise
explanations, making his content informative and engaging for the readers.
When he's not writing, you can find him binging on videos from his favorite tech
YouTubers or diving into immersive open-world games on his trusty old Lenovo
Legion 5 Pro.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  t19 Hetvi">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/hetvi-ranpura" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm27} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Hetvi </p>
                      <p>Ranpura</p>
                    </div>
                    <div className="team__div7">
                  <p>SEO Executive</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon41" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon130"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div174">
                    <p>
                    Hetvi Ranpura is a proficient SEO executive. She has extensive knowledge of
various aspects of SEO, ranging from on-page optimization to off-page strategies
and technical SEO. Besides her professional expertise, she is an ardent traveler,
hiker, dedicated binge-watcher, and enthusiastic foodie. Her diverse interests fuel
her creativity and inspire her to deliver outstanding results in the ever-evolving
world of SEO.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 t19 Vrinda">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/vrindajasapara" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm28} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Vrinda </p>
                      <p>Jasapara</p>
                    </div>
                    <div className="team__div7">
                  <p>SEO Executive</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon42" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon131"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div175">
                    <p>
                    Vrinda is a digital marketing enthusiast with extensive expertise in On-Page SEO,
Off-Page SEO, and Technical SEO. With a strong foundation in optimization, she
excels at enhancing online visibility and achieving organic search engine rankings.
Vrinda revels as an avid learner, constantly adapting to new challenges and
exploring diverse interests such as singing, reading, and binge-watching.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60  t19 Om">
                
                <div className="team__div8">
                  <a href="https://in.linkedin.com/in/omdbagul" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm25} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Om </p>
                      <p>Bagul</p>
                    </div>
                    <div className="team__div7">
                  <p>Cinematographer</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon39" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon128"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div172">
                    <p>
                    Om is a talented Cinematographer/Filmmaker with boundless energy and
exceptional skills in identifying the perfect lighting and aesthetics for videos. He
is a self-cultivated creative individual who has been involved in a variety of
projects ranging from short films to product commercials to song covers. At the
age of 17, he was already winning International Film Contests and providing
wings to his filmmaking career. Creating something new every day is what
drives him, and being a part of the IGM team allows him to do that.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="team__div60 right1 t19 Isha">
                
                <div className="team__div8">
                  <a href="https://www.linkedin.com/in/isha-pipariya-5ab601247/" target="_blank" rel="noopener noreferrer">
                    <div className="team__div9">
                      <img src={tm29} className="team__img1" alt="" />
                    </div>
                  </a>
                  <div className="team__div10">
                    <div className="team__div11">
                      <p>Isha </p>
                      <p>Pipariya</p>
                    </div>
                    <div className="team__div7">
                  <p>Social Media Executive</p>
                </div>
                    <div className="team__div12">
                      <div className="team__div13">
                        <AddIcon id="team__icon43" className="team__icon1" />
                        <RemoveIcon
                          id="team__icon132"
                          className="team__icon100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="team__div14" id="team__div176">
                    <p>
                    Meet our dynamic Social Media Executive, Isha. She has a keen eye for trends
and specializes in crafting compelling social media strategies that drive brand
awareness and engagement. Alongside her expertise in various social media
platforms, you can also find her in the kitchen, creating delicious recipes while
enjoying some music.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </HelmetProvider>
  );
}

export default OurTeam;
